import React, { useState, useEffect } from 'react';
import {
  Table,
  Container,
  Row,
  Col,
  Card, 
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  CardSubtitle} from 'reactstrap';
  import Pagination from '../components/Pagination';
  import useDebounce from '../hooks/useDebounce';
  import numberWithCommas from '../helpers/numberWithCommas';

export default function TerritoryShow({ id, name }) {
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [queryData, setQueryData] = useState({})
  const [loading, setLoading] = useState(false);
  const pageSize = 10

  const debouncedSearch = useDebounce(search, 500);

  useEffect(() => {
    setLoading(true)
    async function fetchData() {
      const params = { page_size: pageSize, page: currentPage }
      if (!!search) params['sku'] = search
      const searchParams = new URLSearchParams(params)
      const response = await fetch(`/api/territories/${id}/inventory?` + searchParams);
      const list = await response.json();
      return (list)
    }

    // call the function
    fetchData()
      .then((res) => {
        setQueryData(res)
        setLoading(false)
      })
      // make sure to catch any error
      .catch(console.error);
  }, [debouncedSearch, currentPage])

  const pageStart = pageSize * (currentPage - 1) + 1
  const totalResults = queryData.count
  const pageSizePageEnd = pageSize * currentPage
  const pageEnd = totalResults < pageSizePageEnd ? totalResults : pageSizePageEnd
  const skuDesc = !!search ? ` that match SKU "${search}"` : ''
  
  const showingNumbers = totalResults < pageSize ? '' : ` items number ${numberWithCommas(pageStart)}-${numberWithCommas(pageEnd)} of`
  const desc = `Showing${showingNumbers} ${numberWithCommas(totalResults)} total inventory items${skuDesc}.`

  return (
    <Container fluid="xl">    
      <Row>
        <Col sm="12">
          <Card body>
            <CardTitle tag="h5">
              Inventory Levels
            </CardTitle>
            <CardSubtitle className="mb-2 text-muted" tag="h6">
              Territory {name}
            </CardSubtitle>
            <Row>
              <Col sm="6">
                <Form style={{ marginTop: 10 }} onSubmit={e => { e.preventDefault(); }}>
                  <FormGroup>
                    <Label for="search">
                      Search:
                    </Label>
                    <Input
                      id="search"
                      name="search"
                      placeholder={loading ? "Searching..." : "Search by SKU..."}
                      type="search"
                      onChange={(e) => {
                        setSearch(e.target.value)
                        setCurrentPage(1)
                      }}
                    />
                  </FormGroup>
                </Form>
              </Col>
            </Row>
            <Row style={{ margin: 10, marginLeft: 4 }}>{desc}</Row>
            <Table striped>
              <thead>
                <tr>
                  <th>SKU</th>
                  <th>Name</th>
                  <th>Vendor</th>
                  <th>Quantity</th>
                  <th>Last Inventory Upadate</th>
                  <th>Cost</th>
                  <th>Default Price</th>
                </tr>
              </thead>
              <tbody>
                {
                  queryData?.items?.length
                    ? (
                      queryData.items?.map((i) => (
                        <tr key={i.sku}>
                          <th scope="row">{i.sku}</th>
                          <td>{i.name}</td>
                          <td>{i.vendor_name}</td>
                          <td>{i.quantity}</td>
                          <td>{i.latest_log_timestamp}</td>
                          <td>{i.cost}</td>
                          <td>{i.default_price}</td>
                        </tr>
                      ))
                    )
                    : <tr><td colSpan={8}>Inventory is not logged for this territory</td></tr>
                }
              </tbody>
            </Table>
            <Pagination
              currentPage={currentPage}
              totalCount={queryData?.count || 0}
              pageSize={pageSize}
              onPageChange={setCurrentPage}
            />
          </Card>
        </Col>
      </Row>
    </Container>
  )
}